import styled from 'styled-components';

import { Legend as LegendComponent } from './legend';
import { getSize } from './charts.helper';

export const Container = styled.div`
  width: ${getSize('width')};
  height: ${getSize('height')};
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 20px;
  justify-content: space-between;
`;

export const Legend = styled(LegendComponent)`
  flex: 1 auto;
`;

export const Chart = styled.div`
  flex: 1 auto;
  position: relative;
  min-height: 100px;
  height: ${getSize('height', 100)};
  display: flex;
`;

export const Svg = styled.svg`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  overflow: visible;

  .vx-line {
    shape-rendering: crispEdges;
  }

  @media print {
    position: static;
    overflow: visible;
  }
`;
